"use client"

import * as React from "react"
import Link from "next/link"
import {AudioWaveform, Command, GalleryVerticalEnd, Search} from "lucide-react"
import {Input} from "@/components/ui/input"
import {OrgSwitcher} from "@/components/org-switcher"
import {
    NavigationMenu,
    NavigationMenuList,
    NavigationMenuItem,
    NavigationMenuLink,
} from "@/components/ui/navigation-menu"
import {SidebarTrigger} from "@/components/ui/sidebar";
import {Separator} from "@/components/ui/separator";
import {useAuth} from "@/context/AuthContext";
import {ThemeSwitcher} from "@/components/theme-switcher";

export function NavBar() {
    const auth = useAuth()
    return (
        <div className="w-full border-b bg-background ">
            <NavigationMenu className="max-w-full flex items-center gap-2 justify-between h-14 px-4 w-full">
                <SidebarTrigger size="lg"></SidebarTrigger>
                <Separator className="ml-1 mr-2" orientation="vertical"/>
                {/* Left: Search */}
                <div className="flex items-center gap-2 w-full max-w-md">
                    <span className="text-muted-foreground">
                        <Search className="h-5 w-5 w-full max-w-md"/>
                    </span>
                    <Input
                        type="search"
                        placeholder="Search…"
                        className="bg-muted text-foreground border-none focus-visible:ring-0 focus-visible:ring-offset-0"
                    />
                </div>

                {/* Right: OrgSwitcher */}
                <div className="ml-auto flex items-center gap-2">
                    <ThemeSwitcher />
                    <OrgSwitcher teams={auth.user!.organizations!}/>
                </div>
            </NavigationMenu>
        </div>
    )
}
